import * as go from 'gojs';
import * as React from 'react';

import {
  isMapping,
  isMappingLabel,
} from 'src/containers/ProjectDiagram/utils/data';
import { changeEntityDrawer } from 'src/store/ui/changeEntityDrawer';
import { useNavigateMapping } from 'src/utils/hooks/useNavigateMapping';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useDiagramObjectDoubleClick = () => {
  const { projectId } = useRouterParams();
  const dispatch = useReduxDispatch();
  const navigateMapping = useNavigateMapping();

  return React.useCallback<
    | NonNullable<go.Diagram['doubleClick']>
    | NonNullable<go.GraphObject['doubleClick']>
  >(
    (_event, targetObject) => {
      const graphObject = targetObject?.part || targetObject;

      if (!graphObject) {
        return;
      }
      if (
        graphObject.part &&
        (isMapping(graphObject.part.data) ||
          isMappingLabel(graphObject.part.data))
      ) {
        navigateMapping(graphObject.part.data.value);
      } else {
        dispatch(
          changeEntityDrawer({ graphObject, isDoubleClick: true, projectId })
        );
      }
    },
    [dispatch, projectId, navigateMapping]
  );
};
